"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable */
var _default = (0, _createSvgIcon["default"])( /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  d: "M13.4142 12l5.6569-5.6569c.3905-.3905.3905-1.0236 0-1.4142-.3906-.3905-1.0237-.3905-1.4143 0L12 10.5858 6.3431 4.9289c-.3905-.3905-1.0236-.3905-1.4142 0-.3905.3906-.3905 1.0237 0 1.4143L10.5858 12l-5.6569 5.6569c-.3905.3905-.3905 1.0237 0 1.4142.3906.3905 1.0237.3905 1.4142 0L12 13.4142l5.6568 5.6569c.3906.3905 1.0237.3905 1.4143 0 .3905-.3905.3905-1.0237 0-1.4142L13.4142 12z",
  clipRule: "evenodd"
})), 'CloseLargeIcon');
/* eslint-enable */


exports["default"] = _default;